@if (showNotice()) {
  <pr-information-box>
    <div class="flex flex-row items-center gap-2">
      <div class="flex flex-1 flex-col gap-1">
        @if (canReleaseHold()) {
          <div>
            Deposit
            <span class="bold">{{ holdAmount() | currency }}</span>
            &mdash; {{ holdNoticeText }}
          </div>
        }
        @if (hasCreditToApply()) {
          <div>
            Credit available to apply:
            <span class="bold">{{ availableCreditTotal() | currency }}</span>
          </div>
        }
        @if (showDepositAddendum()) {
          <div class="text-xs opacity-75">
            {{ bookingDepositTotal() | currency }} of this is a deposit taken
            for this appointment.
          </div>
        }
        @if (creditStateQueryFailed()) {
          <div>
            Credit availability could not be refreshed. Any known credit can
            still be applied manually.
          </div>
        }
      </div>
      @if (creditAvailable()) {
        <pt-loader-button
          type="flat"
          color="primary"
          [loading]="applyingCredit()"
          (clicked)="applyCredit.emit()"
        >
          Apply Credit
        </pt-loader-button>
      }
      @if (canReleaseHold()) {
        <pt-loader-button
          type="stroked"
          color="primary"
          [loading]="releasing()"
          (clicked)="releaseHold()"
        >
          Release Hold
        </pt-loader-button>
      }
    </div>
  </pr-information-box>
}
